import {EnvironmentInjector, Injectable, NgZone, ViewContainerRef} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AuthService} from './auth.service';
import {catchError, map} from 'rxjs/operators';
import {throwError as observableThrowError} from 'rxjs';
import * as ApexCharts from 'apexcharts';
import { take } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})

export class CommonService {
    public printComponentRef: any;

    constructor(private http: HttpClient, public authService: AuthService, private ngZone: NgZone) {}

    async printReport(componentRef?, componentPayload?, calledType = '', chartId = '') {
        if (this.printComponentRef) {
            this.printComponentRef.destroy();
        }
        this.printComponentRef = componentRef;

        Object.entries(componentPayload).forEach(([key, value]) => {
            this.printComponentRef.setInput(key, value);
        });

        this.printComponentRef.changeDetectorRef.detectChanges();

        await new Promise(resolve => setTimeout(resolve, 1000));

        if (calledType == '') {
            try {
                await ApexCharts.exec('feedbackChartPrint', 'destroy');
            } catch {}

            await new Promise(resolve => setTimeout(resolve, 200));

            const chartImage = await ApexCharts.exec(chartId, 'dataURI');

            const chartContainer = document.querySelector('#print-section-essay .chart-container');
            if (chartContainer) {
                chartContainer.innerHTML = `<img src="${chartImage.imgURI}" style="max-width:100%;" alt=""/>`;
            }
        }

        const feedbackEl = document.getElementById('feedback_got_essay');
        if (feedbackEl) {
            feedbackEl.style.display = calledType ? 'none' : 'unset';
        }
        // document.getElementById('feedback_got_essay').style.display = calledType ? 'none' : 'unset';
        const printContents = document.getElementById('print-section-essay')?.innerHTML;
        if (!printContents) return;

        const styles = Array.from(document.styleSheets)
            .map((sheet: any) => {
                try {
                    return Array.from(sheet.cssRules).map((rule: any) => rule.cssText).join('');
                } catch {
                    return '';
                }
            })
            .join('');

        const popupWin = window.open('', '_blank', 'width=auto,height=100%');
        if (!popupWin) {
            this.printComponentRef.destroy();
            return;
        }

        popupWin.document.open();
        popupWin.document.write(`
<html>
<head>
  <title>Feedback Report</title>
  <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css">
  <style>${styles}</style>
  <style>
    body { font-family: "Times New Roman", serif !important; }
    .chart-container { text-align: center; margin: 20px 0; }
    .feedback-card,
    .custom_feedback_card_body,
    .card,
    .card-body,
    .card-header,
    .content-card {
      max-height: none !important;
      overflow: visible !important;
      height: auto !important;
    }
    .apexcharts-tooltip-text { display: none !important; }
    span, h5, p, h6 { font-size: 20px !important; }
    .logo_design { width: auto; height: 36px; }
    @media print {
      html, body { zoom: 100% !important; }
      span, p, h5, h6 { font-size: 20px !important; }
    }
    .f-30 { font-size: 30px !important; }
    @page { size: A4; margin: 10mm; }
    @media print and (min-width: 420mm) { @page { size: A3; margin: 10mm; } }
    @media print {
  header, footer, .header, .footer {
    display: none !important;
  }
}
}
  </style>
</head>
<body>
  <div class="container-fluid py-3 mt-3" style="font-size:20px;">
    <div class="d-flex justify-content-between px-3">
        <span class="f-30 font-weight-bold">Score Report</span>
      <img class="logo_design" src="assets/images/EdQuill.png" alt="Edquill">
    </div>
    ${printContents}
  </div>
  <script>
    window.onafterprint = () => {
      window.close();
    };
    window.onload = () => {
      setTimeout(() => window.print(), 100);
    };
  </script>
</body>
</html>
  `);
        popupWin.document.close();

        setTimeout(() => {
            if (this.printComponentRef) {
                this.printComponentRef.destroy();
                this.printComponentRef = null;
            }
        }, 2000);
    }

    convertBase64PdfPath(b64Data) {
        const byteCharacters = atob(b64Data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        return new Uint8Array(byteNumbers);
    }

    fileUpload(data) {
        const json = JSON.stringify(data);
        const url = 'common/fileUpload';
        return this.http.post(url, json).pipe(
            map(this.extractData),
            catchError(this.handleError));
    }

    tagList(data) {
        const json = JSON.stringify(data);
        const url = 'common/tagsList';
        return this.http.post(url, json).pipe(
            map(this.extractData),
            catchError(this.handleError));
    }

    getSignature(data) {
        const json = JSON.stringify(data);
        const url = 'classes/zoomSignature';
        return this.http.post(url, json).pipe(
            map(this.extractData),
            catchError(this.handleError));
    }

    convertBase64(b64urlData) {
        if (b64urlData != '' && b64urlData.length != 0) {
            let b64Data: any;
            b64Data = atob(atob(atob(atob(b64urlData))));
            b64Data = JSON.parse(b64Data);
            return b64Data;
        } else {
            return b64urlData;
        }
    }

    public downloadfilewithbytes(url: any) {
        console.log(url, 'url');
        return this.http.get(url, {responseType: 'arraybuffer'});
    }

    excelUpload(data) {
        const json = JSON.stringify(data);
        const url = 'common/bulkUpload';
        return this.http.post(url, json).pipe(
            map(this.extractData),
            catchError(this.handleError));
    }

    bulkInsert(data) {
        const json = JSON.stringify(data);
        const url = 'common/bulkInsert';
        return this.http.post(url, json).pipe(
            map(this.extractData),
            catchError(this.handleError));
    }

    emailInviteUpload(data) {
        const json = JSON.stringify(data);
        const url = 'common/emailInvite';
        return this.http.post(url, json).pipe(
            map(this.extractData),
            catchError(this.handleError));
    }

    excelDownload(data) {
        const json = JSON.stringify(data);
        const url = 'common/downloadExcel';
        return this.http.post(url, json).pipe(
            map(this.extractData),
            catchError(this.handleError));
    }

    getStateList(data) {
        const json = JSON.stringify(data);
        const url = 'common/state';
        return this.http.post(url, json).pipe(
            map(this.extractData),
            catchError(this.handleError));
    }

    getCountryList(data) {
        const json = JSON.stringify(data);
        const url = 'common/country';
        return this.http.post(url, json).pipe(
            map(this.extractData),
            catchError(this.handleError));
    }

    studentRegis(data) {
        const json = JSON.stringify(data);
        const url = 'user/getUserDetail';
        return this.http.post(url, json).pipe(
            map(this.extractData),
            catchError(this.handleError));
    }

    saveRegistration(data) {
        const json = JSON.stringify(data);
        const url = 'user/editProfile';
        return this.http.post(url, json).pipe(
            map(this.extractData),
            catchError(this.handleError));
    }

    settingsDetails(data) {
        const json = JSON.stringify(data);
        const url = 'common/settingList';
        return this.http.post(url, json).pipe(
            map(this.extractData),
            catchError(this.handleError));
    }

    dateFormat(data) {
        const json = JSON.stringify(data);
        const url = 'school/dateformat';
        return this.http.post(url, json).pipe(
            map(this.extractData),
            catchError(this.handleError));
    }

    timeZone(data) {
        const json = JSON.stringify(data);
        const url = 'school/timeZoneList';
        return this.http.post(url, json).pipe(
            map(this.extractData),
            catchError(this.handleError));
    }

    editsettings(data) {
        const json = JSON.stringify(data);
        const url = 'common/settingEdit';
        return this.http.post(url, json).pipe(
            map(this.extractData),
            catchError(this.handleError));
    }

    private extractData(res: Response) {
        const body = res;
        return body || {};
    }

    private handleError(error: Response | any) {
        let errMsg: string;
        if (error instanceof Response) {
            // const body = error.json() || '';
            const err = error || JSON.stringify(error);
            errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
        } else {
            errMsg = error.message ? error.message : error.toString();
        }
        return observableThrowError(error);
    }

}
